export default "/images/vendor/flag-icon-css/flags/1x1/ic.svg?5217cbc3b14b1f23840ff219f23820a9";